import { useLocaleStore } from '../stores/localeStore';
import { translate } from './translate';
import type { MessageKey, TranslateParams } from './types';

export function useTranslation() {
  const locale = useLocaleStore((state) => state.locale);

  return {
    locale,
    t: (key: MessageKey, params?: TranslateParams) => translate(locale, key, params),
  };
}
